export default "__VITE_ASSET__hEj30qUm__"